const WP_API_BASE = '/wp-json/pch/v2/njdiet/'

let postsShowed = 8
let postsLoaded = 10
let perPageLoad = 2

let postsShowedRewies = 20
let postsLoadedRewies = 30
let perPageLoadRewies = 10

let postsShowedVideo = 6
let postsLoadedVideo = 8
let perPageLoadVideo = 2

const initialState = {
  isLoading: false,
  isLoaded: false,
  error: null,
  activePostType: 'user_quote',
  posts: {},
  states: {
    user_quote: {
      postsShowed: postsShowedRewies,
      postsLoaded: postsLoadedRewies,
      perPageLoad: perPageLoadRewies,
      allPostsLoaded: false,
      firstShow: true,
    },
    before_after: {
      postsShowed: postsShowed,
      postsLoaded: postsLoaded,
      perPageLoad: perPageLoad,
      allPostsLoaded: false,
      firstShow: true,
    },
    video: {
      postsShowed: postsShowedVideo,
      postsLoaded: postsLoadedVideo,
      perPageLoad: perPageLoadVideo,
      allPostsLoaded: false,
      firstShow: true,
    },
  },
}

const LOAD_TESTIMONIALS_DATA = 'LOAD_TESTIMONIALS_DATA'
const LOAD_TESTIMONIALS_DATA_SUCCESS = 'LOAD_TESTIMONIALS_DATA_SUCCESS'
const LOAD_TESTIMONIALS_DATA_FAILURE = 'LOAD_TESTIMONIALS_DATA_FAILURE'
const SET_POSTS_STATES = 'SET_POSTS_STATES'
const SET_POSTS_TYPE_ACTIVE = 'SET_POSTS_TYPE_ACTIVE'

export default (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case LOAD_TESTIMONIALS_DATA:
      return {
        ...state,
        isLoading: true,
      }

    case LOAD_TESTIMONIALS_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        posts: { ...state.posts, ...payload },
        error: false,
      }

    case LOAD_TESTIMONIALS_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
      }

    case SET_POSTS_STATES:
      return {
        ...state,
        states: { ...state.states, ...payload },
      }

    case SET_POSTS_TYPE_ACTIVE:
      return {
        ...state,
        activePostType: payload,
      }

    default:
      return state
  }
}

export const loadPosts = (per_page, offset, post_type) => (
  dispatch,
  getState
) => {
  dispatch({ type: LOAD_TESTIMONIALS_DATA })

  // if (getState().posts.isLoaded) return

  // Rest API Params
  const params = {}

  post_type ? (params['post_type'] = post_type) : ''
  per_page ? (params['per_page'] = per_page) : ''
  offset ? (params['offset'] = offset) : ''

  let url_params = '/'
  if (params) {
    let i = 0
    for (let key in params) {
      params.hasOwnProperty(key)
        ? (url_params += (i === 0 ? '?' : '&') + key + '=' + params[key])
        : false
      i++
    }
  }

  let currentPosts = getState().testimonials.posts[post_type]
  if (currentPosts === undefined) {
    currentPosts = new Array()
  }

  return fetch(`${WP_API_BASE}testimonials${url_params}`, {
    method: 'GET',
  })
    .then(response => {
      if (response.ok && response.status === 200) {
        return response.json()
      }
      throw new Error(response.statusText)
    })
    .then(posts => {
      const payload = {}
      payload[post_type] = currentPosts.concat(posts)
      dispatch({
        type: LOAD_TESTIMONIALS_DATA_SUCCESS,
        payload,
      })

      return posts
    })
    .catch(error => {
      if (process.env.NODE_ENV === 'development') {
        console.error(error) //eslint-disable-line
      }
      dispatch({
        error: error,
        type: LOAD_TESTIMONIALS_DATA_FAILURE,
      })
    })
}

export const changeStates = (states, post_type) => (dispatch, getState) => {
  let currentStates = getState().testimonials.states[post_type]
  const payload = {}
  payload[post_type] = { ...currentStates, ...states }
  return dispatch({
    type: SET_POSTS_STATES,
    payload,
  })
}

export const changePostType = post_type => dispatch => {
  const payload = post_type
  return dispatch({
    type: SET_POSTS_TYPE_ACTIVE,
    payload,
  })
}
